import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CandidatesService , AuthService} from '../../services';

@Component({
  selector: 'ngx-candidate-cv',
  templateUrl: 'candidate-cv.component.html',
  styleUrls: ['candidate-cv.component.scss'] 
})
export class CanidadateCVComponent implements OnInit{
   @Input() candidate:any = null;
   currentUser = null;
   id = 0;
   YearCount      = 0;
   fileChanged    = false;
   isImageLoading = false;
   initLoading    = false;
   scannedDoc     = "";
   img_file       = null;
  constructor(private apiService : CandidatesService, private authService :AuthService) {
    this.authService.valueSource.subscribe(user => {this.currentUser = user; });
  }

  ngOnInit(){
    this.initLoading = true;
    this.authService.getCandidateInfo().subscribe((res: any) => {this.currentUser = res.data; this.loadData();},
      (error)=>{this.currentUser = null;},
      ()=>{this.authService.user = this.currentUser;}
    );
  }

  loadData(){
    this.apiService.get(this.authService.user.candidate?.id).subscribe((res: any) =>{
      this.candidate = res.data;
      this.initLoading = false;
    },(error)=>{this.initLoading = false;});
  }

  getDegree(obj){
    switch (obj.degree) {
      case "h_school":
        return "High School";
        break;
      case "p_school":
        return "Primary School";
        break;
    }
    return obj.degree;
  }

  getNameEn(){
    var first_name = this.candidate.first_name ? this.candidate.first_name : '';
    var father_name = this.candidate.father_name ? this.candidate.father_name : '';
    var last_name = this.candidate.last_name ? this.candidate.last_name : '';

    return first_name +' '+father_name+' '+ last_name;
  }

  getNameAr(){
    var ar_first_name = this.candidate.ar_first_name ? this.candidate.ar_first_name : '';
    var ar_father_name = this.candidate.ar_father_name ? this.candidate.ar_father_name : '';
    var ar_last_name = this.candidate.ar_last_name ? this.candidate.ar_last_name : '';

    return ar_first_name +' '+ar_father_name+' '+ ar_last_name;
  }

  getTitle(){
    return this.candidate.address_country?.country_name_en+' - '+this.candidate.address_city?.city_name_en;
  }

  getContacts(type){
    var tel = (this.candidate.address_country?.dial_key?'+'+this.candidate.address_country?.dial_key:'')+ (this.candidate.address_mob_1 ? this.candidate.address_mob_1 : '');
    var n_Tel = (this.candidate.address_country?.dial_key?'+'+this.candidate.address_country?.dial_key:'')+(this.candidate.address_tel_1 ? this.candidate.address_tel_1 : '');

    return type=='tel' ?  tel : n_Tel;
  }

  getMartialInfo(){
    switch (this.candidate.maritial_status) {
      case "s":
        return "Single";
        break;
      case "m":
        return "Married";
        break;
      case "d":
        return "Divorced";
        break;  
      case "w":
        return "Widowed";
        break;  
    }
  }

  getMilitaryInfo(){
    switch (this.candidate.military_service) {
      case "served":
        return "Served";
        break;
      case "not_served":
        return "Not Served";
        break;
      case "exempted":
        return "Exempted";
        break;  
      case "not_applicable":
        return "Not Applicable";
        break;  
    }
  }

  getMilitaryBadge(){
    switch (this.candidate.military_service) {
      case "served":
        return "custom_badge_success";
        break;
      case "not_served":
        return "custom_badge_danger";
        break;
      case "exempted":
        return "custom_badge_info";
        break;  
      case "not_applicable":
        return "custom_badge_primary";
        break;  
    }
  }

  getGenderInfo(){
    return this.candidate.gender == 'm' ? "Male" : "Female" ;
  }

  getYearBadge(){
    var totalMonths = 0;
    var maxDiff = 0;
    var minDate = 0;
    var maxDate = 0;
    if(this.candidate.professional_experience.length > 0){
      for (var i = 0; i < this.candidate.professional_experience.length; ++i) {
        var obj = this.candidate.professional_experience[i];
        if(!obj.is_present)
          totalMonths += this.monthDiff(new Date(obj.start_date),new Date(obj.end_date));
        else{
          const _totalMonths = this.monthDiff(new Date(obj.start_date),new Date());
          if(maxDiff <= _totalMonths)
            maxDiff = _totalMonths;
        }
      }
      totalMonths += maxDiff

      return Math.round(totalMonths/12);
    }
    return 0;
  }

  monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
  }

  BadgeColor(){
    if (this.YearCount >= 7 )
        return "success"
    if (this.YearCount >= 5 )
        return "info"  
    if (this.YearCount >= 1.5 )
        return "warning"  
    return "danger"  
  }  

  getDegreeString(degree){
        switch (degree) {
            case "h_school":
                return "High School Of"
                break;
            case "p_school":
                return "Primary School Of"
                break;
            case "Bachelor":
                return "Bachelor From"
                break;    
            default:
                return degree+" in";
                break;
        }
    }

    getRelaitonshipString(relaitonship){
        switch (relaitonship) {
            case 1007 : 
                return "Previous Line Manager";
                break;
            case 1008 : 
                return "Present Line Manager";
                break;
            case 1009 : 
                return "Previous Indirect Manager";
                break;
            case 1010 : 
                return "Present Indirect Manager";
                break;
            case 1011 : 
                return "Previous Colleague";
                break;
            case 1012 : 
                return "Present Colleague";
                break;
            case 1013 : 
                return "Previous Subordinate";
                break;
            case 1014 : 
                return "Present Subordinate";
                break;
            case 1015 : 
                return "Non-work related Acquaintance";
                break;
        }
        return "Other";
    }
}